export enum NotificationType {
	General,
	RecordAssignedToUser,
	RecordUpdatedByAnotherUser
}

export interface CasesNotification {
	id: string;
	created: Date;
	type: NotificationType;
	title: string;
	message: string;
	data: any;
	targetId: string;
	sentDateTime: Date | null;
}
